<template>
  <div :class="`mdn-Input ${ !value || 'mdn-Input--activatedField'}`">
    <input
      :class="`mdn-Input-field ${ error ? 'is-invalid' : ''}`"
      :name="name"
      type="week"
      data-mdn-type="date"
      v-model="value"
      data-mdn-mask="99999-999"
      @change="updateValue"
      :aria-invalid="!!error"
      :disabled="disabled"
      :readonly="readOnly"
      :ref="name"
      :max="maxWeek"
      :min="minWeek"
    >
    <label for="date" class="mdn-Input-label">{{ placeholder }}</label>
    <small class="mdn-Input-errorFeedback">Por favor, preencha este campo corretamente.</small>
  </div>
</template>

<script>
export default {
  name: "SGPFormSemanaComponent",

  props: {
    placeholder: {
      type: String,
      required: false,
      default: "Semana"
    },
    
    name: {
      type: String,
      required: true,
    },

    parse: {
      type: Boolean,
      required: false,
      default: true,
    },

    value: {
      type: [String, Number],
      required: true,
      default: ''
    },

    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    },

    maxWeek: {
      type: String,
      required: false,
    },

    minWeek: {
      type: String,
      required: false,
    },

    error: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    updateValue () {
      if (this.parse) {
        this.value = this.value.split('/').reverse().join('-')
      }

      if (this.time) {
        this.value = this.value.replace('T', ' ')
      }
      
      this.$emit('input', this.value)
      this.$emit('change', this.value)
    }
  }

  
}
</script>